/* Predictive suggestions for the inline header search box.
   Reuses the theme's predictive-search section rendering via /search/suggest. */
(function () {
  var form = document.getElementById('header-search-form');
  if (!form) return;
  var input = form.querySelector('input[name="q"]');
  var results = document.getElementById('header-search-results');
  if (!input || !results) return;
  var timer = null, ctrl = null;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }
  function hide() { results.classList.add('hidden'); results.innerHTML = ''; }
  function show(html) {
    results.innerHTML = html;
    results.classList.remove('hidden');
    if (window.lucide) lucide.createIcons();
  }
  function fetchResults(q) {
    if (!q) { hide(); return; }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var params = new URLSearchParams({
      q: q,
      'resources[type]': 'product,query,collection',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      section_id: 'predictive-search'
    });
    fetch(root() + 'search/suggest?' + params.toString(), { signal: ctrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('predictive-search-results');
        if (el) { show(el.outerHTML); } else { hide(); }
      })
      .catch(function (err) { if (err.name !== 'AbortError') hide(); });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    timer = setTimeout(function () { fetchResults(q); }, 200);
  });
  input.addEventListener('focus', function () {
    var q = input.value.trim();
    if (q) fetchResults(q);
  });
  document.addEventListener('click', function (e) {
    if (!form.parentNode.contains(e.target)) hide();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
})();
